module.exports = __webpack_public_path__ + "img/whatsapp.b86dfbb2.png";